import * as React from 'react';
import {Spinner} from 'react-bootstrap';
import { useAppComponentStore } from './stores/appComponentStore';

/**
 * 処理中のプログレス表示用（画面最前に表示）
 * @param  
 * @returns 
 */
export const AppProgressBar = () =>{
    const store = useAppComponentStore((state) => state.progress);

    let style:React.CSSProperties = {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor:"rgba(0, 0, 0, 0.3)",
        zIndex:"9999",
        display: "none",
        justifyContent:"center",
        alignItems:"center",
    }
    if( store.isDisplay )
        style.display = "flex";
    else
        style.display = "none";

    const appProgress = React.useMemo(()=> {
        return(
            <div style={style}>
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="row">
                        <Spinner variant="primary" animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                    <div className="row">
                        <strong>Loading...</strong>
                    </div>
                </div>
            </div>
        );
    }, [store.isDisplay]);

    return(
        <>
            {appProgress}
        </>
    );
}